import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ResetPassword() {
  const apiUrl = process.env.REACT_APP_API_URL; // Get the API URL from the .env file
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Separate state for confirm password
  const [loading, setLoading] = useState(false);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const focusInputRef = useRef(null); // Ref for the username input
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword); // Toggle confirm password visibility
  const location = useLocation(); // useLocation hook from react-router-dom
  const { username } = location.state || {};
  useEffect(() => {
    if (!username) {
      navigate(-1);
    }
  }, [username, navigate]);

  useEffect(() => {
    // Focus on the username input when the component mounts
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  }, []);

  const handleApi = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Passwords do not match.');
      return;
    }

    if (password.length < 6) {
      toast.error('Password must be at least 6 characters long.');
      return;
    }

    setLoading(true);

    const data = {
      username: username,
      newPassword: password,
    };

    try {
      const response = await axios.post(
        `${apiUrl}/api/auth/forgot-password`,
        data,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      if (response.status === 200) {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate('/'); // Redirect to login page
        }, 2000);
        setPassword('');
        setConfirmPassword('');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <div>
        <div className="starsec"></div>
        <div className="starthird"></div>
        <div className="starfourth"></div>
        <div className="starfifth"></div>
      </div>
      <div id="Login-page">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center py-4">
                  <a
                    href="index.html"
                    className="logo d-flex align-items-center w-auto"
                  >
                    <img src="assets/img/logo.png" alt="" />
                    <span className="d-none d-lg-block">PRiNTF</span>
                  </a>
                </div>
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="pt-4 pb-2">
                      <h5 className="card-title text-center pb-0 fs-4">
                        Reset Your Password
                      </h5>
                      <p className="text-center small">
                        Enter your new Password
                      </p>
                    </div>
                    <form onSubmit={handleApi}>
                      <div className="row g-3">
                        <div className="col-12">
                          <label htmlFor="newPassword" className="form-label">
                            New Password
                          </label>
                          <div className="input-group has-validation">
                            <input
                              id="newPassword"
                              className="form-control"
                              ref={focusInputRef}
                              value={password}
                              onChange={handlePasswordChange}
                              type={showPassword ? 'text' : 'password'}
                              placeholder="Enter your new Password"
                              required
                            />
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={togglePasswordVisibility}
                            >
                              {showPassword ? (
                                <i className="bi bi-eye-fill"></i>
                              ) : (
                                <i className="bi bi-eye-slash"></i>
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="col-12">
                          <label
                            htmlFor="confirmPassword"
                            className="form-label"
                          >
                            Confirm Password
                          </label>
                          <div className="input-group has-validation">
                            <input
                              id="confirmPassword"
                              className="form-control"
                              value={confirmPassword}
                              onChange={handleConfirmPasswordChange}
                              type={showConfirmPassword ? 'text' : 'password'}
                              placeholder="Confirm your new Password"
                              required
                            />
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={toggleConfirmPasswordVisibility}
                            >
                              {showConfirmPassword ? (
                                <i className="bi bi-eye-fill"></i>
                              ) : (
                                <i className="bi bi-eye-slash"></i>
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="col-12">
                          <button
                            className="btn btn-primary w-100"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>{' '}
                                Please wait...
                              </>
                            ) : (
                              <>Reset Password</>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="credits">
                  Designed by{' '}
                  <Link to="https://printftech.com/" target="_blank">
                    PRiNTF
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <ToastContainer />
    </main>
  );
}

export default ResetPassword;
